export default __webpack_public_path__ + "static/media/empty.5c729b6b.svg";